
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Contract } from 'app/models/contract.model';
import { ContractService } from 'app/services/contract.service';
import { ToasterService } from 'app/services/user-interaction/services/toaster.service';
import { BaseFormComponent } from "../../base-form.component";
import { ContractListComponent } from '../contract-list/contract-list.component';
import { CompanyService } from 'app/services/company.service';
import { CustomFuelInformation } from 'app/models/custom-fuel-information.model';
import { CustomFuelInformationListComponent } from '../custom-fuelInformation-list/custom-fuelInformation-list.component';

@Component({
    selector: 'app-custom-fuelInformation-form',
    templateUrl: './custom-fuelInformation-form.component.html',
    styleUrls: ['./custom-fuelInformation-form.component.scss']
})
export class CustomFuelInformationFormComponent extends BaseFormComponent implements OnInit {

    private _fuelInformation: CustomFuelInformation = {
        status: true
    }

    private _fuelInformationList: Array<CustomFuelInformation>;
    public get fuelInformationList() {
        return this._fuelInformationList;
    }
    public set fuelInformationList(v:Array<CustomFuelInformation>) {
         this._fuelInformationList = v;
    }

    public get model() {
        return this._fuelInformation
    }
    public set model(v: CustomFuelInformation) {
        this._fuelInformation = v;
    }

    constructor(
        private toasterService: ToasterService,
        private _translateService: TranslateService,
        private _companyService: CompanyService,
        public dialogRef: MatDialogRef<CustomFuelInformationListComponent>,
        @Inject(MAT_DIALOG_DATA) public data
    ) {
        super();
    }

    public async ngOnInit() {
    }

    async save() {
        if (this.form.invalid) {
            this.toasterService.toastWarning(this._translateService.instant("PLEASE_FILL_IN_THE_FORM_CORRECTLY"))
            return
        }
        if(this.fuelInformationList){
            var statusControl = this.fuelInformationList.findIndex(e => e.status == true);
            if (statusControl > -1 && this.model.status == true) {
                this.toasterService.toastWarning(this._translateService.instant("THERE_IS_ALREADY_AN_ACTIVE_FUELINFORMATION"))
                return;
            }
        }
        this.model.companyId = this.data.id;

        try {
            await this._companyService.addCustomFuelInformation(this.model);
            this.added.emit(true);
        } catch (error) {
            console.warn(error);
            this.added.emit(false);
        }

    }

}
